export default __webpack_public_path__ + "static/onboard-fund-house-f4565bbc8b272fb84289eca72d718dac.png";